import type { ComposerDraftStore } from '@reachinsight-app/shared/src/components/R3Chat/types'

/** One draft shared by the normal Ros composer and the composer anchored to a selected element. */
export class WebsiteComposerDraftStore implements ComposerDraftStore {
  private value = ''
  private listeners = new Set<() => void>()

  getSnapshot = () => this.value

  setValue = (value: string) => {
    if (value === this.value) return
    this.value = value
    for (const listener of this.listeners) listener()
  }

  subscribe = (listener: () => void) => {
    this.listeners.add(listener)
    return () => { this.listeners.delete(listener) }
  }
}
